import script from "./ModalDuvidaReportada.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalDuvidaReportada.vue?vue&type=script&setup=true&lang=js"

import "./ModalDuvidaReportada.vue?vue&type=style&index=0&id=10f54eff&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10f54eff"]])

export default __exports__